<template>
  <div>
    <div class="main-container">
      <VaSkeletonGroup animation="wave">
        <div>
          <VaCardContent class="flex items-center skeleton-container">
            <div class="image-container">
              <VaSkeleton variant="squared" :width="imageSize" :height="imageSize" />
            </div>
            <div class="text-container">
              <div class="teft-section">
                <VaSkeleton variant="text" class="ml-2" :lines="2" />
                <VaSkeleton variant="rounded" inline width="70px" height="30px" style="margin-top: 0.6rem; margin-left: 0.5rem" />
                <VaSkeleton variant="rounded" inline width="100px" height="35px" style="margin-top: 1.5rem; margin-left: 0.5rem" />
              </div>
              <div class="button-content">
                <VaSkeleton
                  class=""
                  variant="rounded"
                  inline
                  width="150px"
                  height="35px"
                />
              </div>
            </div>
          </VaCardContent>
        </div>
      </VaSkeletonGroup>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  created() {},
  data() {
    return {};
  },
  props: {},
  methods: {},
  computed:{
    imageSize(){
      if(window.innerWidth <= 500){
        return '8rem';
      }else{
        return '10rem'
      }
    }
  }
};
</script>

<style lang="sass" scoped>
.main-container
  height: auto
  //margin: 0.5rem
  background-color: #fff
  border-radius: 5px
  margin-top: 0.5rem
  @media (max-width: 500px)
    margin: 1rem
.skeleton-container
  display: flex
.image-container
  width: 3%
  height: 100%
  display: flex
  justify-content: center
  align-items: center
  //margin-top: 0.5rem
  @media (max-width: 500px)
    margin-top: 1rem
    width: 35%
.text-container
  //margin-top: 0.5rem
  width: 70%
  text-align: left
  @media (max-width: 500px)
    margin-top: 1rem
.button-content
  display: flex
  justify-content: flex-end
  margin-right: 1rem
  @media (max-width: 500px)
    display: none
</style>